import React from 'react'

const WholeHouseFurniture = () => {
  return (
    <div>WholeHouseFurniture</div>
  )
}

export default WholeHouseFurniture